import React from 'react'

import IcWarningCircle from '@interco/icons/core/status/ic_warning_circle'
import { Checkbox } from '@interco/inter-ui/components/Checkbox'
import { Box } from '@atoms'
import { Colors } from '@utils/Colors'
import { Contrato } from '@store/refinanciamento/contratos/types'
import { ValorParcela } from '@molecules'

interface ContratoIndisponivelProps {
  contrato: Contrato
  contratoIndex: number
  onClick: () => void
  isDisabled: boolean
}

const ContratoIndisponivel = ({
  contrato,
  contratoIndex,
  onClick,
  isDisabled,
}: ContratoIndisponivelProps & React.HTMLAttributes<HTMLDivElement>) => (
  <Box justify="space-between" margin="16px 0px" key={contrato.numeroContrato}>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick()
      }}
      onClick={onClick}
    >
      <ValorParcela contrato={contrato} isDisabled={isDisabled} />
      <Checkbox
        disabled
        reversed
        id={`checkbox-contrato-${contrato.numeroContrato}-${contratoIndex}`}
        checked={false}
        label={<IcWarningCircle height={24} width={24} color={Colors.ALERT500} />}
      />
    </div>
  </Box>
)

export default ContratoIndisponivel
